import { Box } from 'lucide-react';
import type { SVGProps } from 'react';

type IconProps = Pick<SVGProps<SVGSVGElement>, 'className' | 'width' | 'height'>;

/** 3D 厂商暂无 lobehub 品牌标时的共用立方体图标 */
function ThreedBrandIcon({ className, width, height, label }: IconProps & { label: string }) {
  return <Box className={className} width={width} height={height} aria-label={label} />;
}

export const HunyuanIcon = (props: IconProps) => (
  <ThreedBrandIcon {...props} label="Hunyuan" />
);

export const Hyper3dIcon = (props: IconProps) => (
  <ThreedBrandIcon {...props} label="Hyper3D" />
);

export const Tripo3dIcon = (props: IconProps) => (
  <ThreedBrandIcon {...props} label="Tripo3D" />
);
